import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

export enum ToastLevel
{
  WARNING = 'warning',
  ERROR = 'error',
}

@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  styleUrls: [ './toast.component.scss' ],
})
export class ToastComponent {
  private static DISPLAY_TIME: number = 3000;

  public message: string = '';
  public level: ToastLevel = ToastLevel.ERROR;
  public visible: boolean = false;
  public animate: boolean = false;

  private hideTimeout: any = undefined;

  constructor(
      private mir: MatIconRegistry,
      private sanitizer: DomSanitizer)
  {
    this.mir.addSvgIcon(
        'toast',
        this.sanitizer.bypassSecurityTrustResourceUrl(
            'assets/img/icons/toast.svg'));
  }

  public show(message: string, level = ToastLevel.ERROR): void
  {
    this.message = message;
    this.level = level;

    this.visible = true;
    this.animate = true;

    this.clearHideTimeout();
    this.hideTimeout = setTimeout(
      this.hide.bind(this), ToastComponent.DISPLAY_TIME);
  }

  public hide(): void
  {
    this.visible = false;
    this.animate = true;
    this.clearHideTimeout();
  }

  private clearHideTimeout(): void
  {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = undefined;
    }
  }

  public onAnimationEnd(): void
  {
    this.animate = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/toast/toast.component.ts